<template>
  <div>
    <slot />
  </div>
</template>

<script setup lang="ts">
import { format } from 'date-fns'

import type { BranchData } from '@/types/api'
import type { SlotInfo } from '@/types/product'

import { DEFAULT_RESTAURANT_ATTENDANCE } from '@/constants/commons'

interface Props {
  branch: Nullable<BranchData>
  isSoldOut: boolean
}

const props = defineProps<Props>()
const { branch, isSoldOut } = toRefs(props)

const attendance = defineModel<number>('attendance', { default: DEFAULT_RESTAURANT_ATTENDANCE })
const date = defineModel<Nullable<string>>('date', { default: format(new Date(), 'yyyy-MM-dd') })
const slotInfo = defineModel<Nullable<SlotInfo>>('slotInfo', { default: null })

const context = { branch, attendance, date, slotInfo, isSoldOut }

useBranchDetailProvider(context)
</script>
